module.exports = __webpack_public_path__ + "static/media/time.c52ce550.jpg";